// Utilitário para acessar variáveis de ambiente com fallback para Cypress

export const getEnvVar = (key: string, defaultValue: string = ""): string => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key] || defaultValue;
  }
  return defaultValue;
};

export const getEnvVarBoolean = (key: string, defaultValue: boolean = false): boolean => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key] || defaultValue;
  }
  return defaultValue;
};

// Funções específicas para variáveis comuns
export const getApiUrl = (): string => {
  return getEnvVar('VITE_API_URL', '');
};

export const getIntegrationsHubApiUrl = (): string => {
  return getEnvVar('VITE_INTEGRATIONS_HUB_API_URL', '');
};

export const getIntegrationsHubApiKey = (): string => {
  return getEnvVar('VITE_INTEGRATIONS_HUB_API_KEY', '');
};

export const getPusherAppKey = (): string => {
  return getEnvVar('VITE_PUSHER_APP_KEY', '');
};

export const getGoogleClientId = (): string => {
  return getEnvVar('VITE_GOOGLE_CLIENT_ID', '');
};

export const getEnvMode = (): "dev" | "hml" | "prod" => {
  return getEnvVar('VITE_ENV', 'dev') as "dev" | "hml" | "prod";
};

export const isDevelopment = (): boolean => {
  return getEnvVarBoolean('DEV', true);
};
